import React from 'react';

import { useInfiniteQuery, UseInfiniteQueryOptions } from '@lumapps/base-api/react-query';
import { marketplaceConnectorsQueryKeys } from '@lumapps/connectors/api';
import { ConnectorSearchParam } from '@lumapps/connectors/hooks/useConnectorsList';
import { CONNECTOR_SORT, ConnectorListResponse } from '@lumapps/connectors/types';

import { fetchExtensionConnectors, FetchExtensionConnectorsParams } from '../api';

export const useExtensionConnectorList = (
    params: Pick<FetchExtensionConnectorsParams, 'extensionId' | 'site'>,
    options?: UseInfiniteQueryOptions,
) => {
    const [search, setSearch] = React.useState<ConnectorSearchParam>({
        name: undefined,
        protocol: undefined,
        providerType: undefined,
        hasPartner: undefined,
    });

    const [sort, setSort] = React.useState<CONNECTOR_SORT>();

    const query = useInfiniteQuery<ConnectorListResponse>({
        ...options,
        queryKey: marketplaceConnectorsQueryKeys.connectors({ ...params, ...search, sort }),
        getNextPageParam: (lastPage) => (lastPage.more ? lastPage.cursor : undefined),
        queryFn: async ({ pageParam: cursor }) => {
            const response = await fetchExtensionConnectors({ ...params, cursor, searchParams: search, sort });
            return response.data;
        },
    });

    return React.useMemo(
        () => ({
            ...query,
            setSearchParams: setSearch,
            searchParams: search,
            setSortParam: setSort,
            sortParam: sort,
        }),
        [query, search, sort],
    );
};
